"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var yup = _interopRequireWildcard(require("yup"));
var _core = require("@material-ui/core");
var _reactRouterDom = require("react-router-dom");
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../config");
var _reactRedux = require("react-redux");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RegisterSuccess = function RegisterSuccess() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.registerReducer;
    }),
    inProgress = _useSelector.inProgress;
  var email = sessionStorage.getItem('email');
  var isValidEmail = yup.string().email().isValidSync(email);
  var handleResendConfirmation = function handleResendConfirmation() {
    dispatch({
      type: 'RESEND_CONFIRMATION_EMAIL'
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 3,
    className: "p-12 m-12 mx-auto",
    style: {
      maxWidth: '444px'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(_config.BASE_URL)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _config.LOGO_PATH,
    alt: "Logo",
    width: "220"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12,
    justify: "center",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Votre inscription a bien \xE9t\xE9 prise en compte. Votre compte sera valid\xE9 sous 48h.",
    defaultMessage: "Votre inscription a bien \xE9t\xE9 prise en compte. Votre compte sera valid\xE9 sous 48h."
  }))), isValidEmail && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12,
    justify: "center",
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "If you didn't receive the confirmation email in {email}, please check your spam folder or click on the button below to resend it.",
    defaultMessage: "If you didn't receive the confirmation email in {email}, please check your spam folder or click on the button below to resend it.",
    values: {
      email: email
    }
  }))), isValidEmail && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12,
    justify: "center",
    style: {
      marginTop: 28
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: inProgress,
    variant: "contained",
    color: "primary",
    onClick: handleResendConfirmation
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Resend confirmation email",
    defaultMessage: "Resend confirmation email"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12,
    justify: "center",
    style: {
      marginTop: isValidEmail ? 16 : 28
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/login",
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Go to the home page",
    defaultMessage: "Go to the home page"
  }))))));
};
var _default = RegisterSuccess;
exports.default = _default;